// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jwoB","label":"styles_label__3ky3B"};